import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ENDPOINTS from "../../config/apiUrls";
import { getRequest, postRequest } from "../../config/dataApi";
import axiosInstance from "../../config/axiosInstance";
import { toast } from "react-toastify";
import { getOffset, getToken } from "../../helpers/utils";


export const getParticipants = createAsyncThunk("users/getParticipants", async ({ page = 1, limit = 10 }, { getState }) => {
  try {
    const { auth } = getState();
    const roomId = auth?.user?.attributes?.stationChatId;
    const response = await postRequest(ENDPOINTS.CHAT.USERS, { roomId, limit, offset: page == 1 ? 0 : getOffset(page, limit) });
    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch users");
  }
});

export const getParticipantsForExport = createAsyncThunk("users/getParticipantsForExport", async (_, { getState }) => {
  try {
    const { auth } = getState();
    const roomId = auth?.user?.attributes?.stationChatId;
    const response = await postRequest(ENDPOINTS.CHAT.USERS, { roomId, limit:10000, offset:0 });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch users");
  }
});



export const blockParticipant = createAsyncThunk('team/blockParticipant',
  async ({ message = 'Profile updated successfully', reason = null, id }, { rejectWithValue, getState }) => {
    try {
      if (!id) {
        return rejectWithValue("User not found.");
      }
      const { auth } = getState();
      const roomId = auth?.user?.attributes?.stationChatId;

      const requestData = {
        id: id,
        reason,
        roomId,
        token: getToken()
      };
      const response = await axiosInstance.post(ENDPOINTS.CHAT.PARTICIPANT_BAN, requestData);
      if (response.status === 200) {
        toast.success(message, {
          position: "top-right",
          autoClose: 3000,
        });

        return { id };
      } else {
        return rejectWithValue('Failed to update profile.');
      }
    } catch (error) {
      console.log(error.message);
      return rejectWithValue(error.response?.data?.message || 'An error occurred.');
    }
  }
);

export const  unblockParticipant = createAsyncThunk('team/unblockParticipant',
  async ({ message = 'Profile updated successfully', id }, { rejectWithValue, getState }) => {
    try {
      if (!id) {
        return rejectWithValue("User not found.");
      }
      const { auth } = getState();
      const roomId = auth?.user?.attributes?.stationChatId;

      const requestData = {
        id: id,
        roomId,
        token: getToken()
      };
      const response = await axiosInstance.post(ENDPOINTS.CHAT.PARTICIPANT_UNBAN, requestData);
      if (response.status === 200) {
        toast.success(message, {
          position: "top-right",
          autoClose: 3000,
        });

        return { id };
      } else {
        return rejectWithValue('Failed to update profile.');
      }
    } catch (error) {
      console.log(error.message);
      return rejectWithValue(error.response?.data?.message || 'An error occurred.');
    }
  }
);

const participantSlice = createSlice({
  name: "participant",
  initialState: {
    users: [],
    allUsers: [],
    meta: {
      currentPage: 1,
      totalPages: 1,
      totalRecords: 10,
    },
    totalPages: 1,
    loading: false,
    exportLoading : false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getParticipants.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getParticipants.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload.data;
        state.meta = action.payload.meta
      })
      .addCase(getParticipants.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(getParticipantsForExport.pending, (state) => {
        state.exportLoading = true;
        state.error = null;
      })
      .addCase(getParticipantsForExport.fulfilled, (state, action) => {
        state.exportLoading = false;
        state.allUsers = action.payload;
      })
      .addCase(getParticipantsForExport.rejected, (state, action) => {
        state.exportLoading = false;
        state.error = action.error.message;
      })
      .addCase(blockParticipant.fulfilled, (state, action) => {
        const { id } = action.payload;
        state.users = state.users.map(member =>
          member.id === id
            ? { ...member, attributes: { ...member.attributes, bannedAt: true } }
            : member
        );
      })
      .addCase(unblockParticipant.fulfilled, (state, action) => {
        const { id } = action.payload;
        state.users = state.users.map(member =>
          member.id === id
            ? { ...member, attributes: { ...member.attributes, bannedAt: false } }
            : member
        );
      });
  },
});

export default participantSlice.reducer;
